import { OneAlert } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { WorkAreaMapLocationNode } from 'modules/space_control/hooks/useWorkAreaMap'

interface PinAlertProps {
  workSpace: WorkAreaMapLocationNode
  onDelete: () => void
}

export const PinAlert: React.FC<PinAlertProps> = ({ workSpace, onDelete }) => (
  <OneAlert
    title={workSpace.workSpace?.name ?? ''}
    description={i18n.t('space_control.map.space_mapped')}
    variant="info"
    action={{
      label: i18n.t('space_control.map.remove_from_map'),
      onClick: onDelete,
    }}
  />
)
